import { useState, useEffect, useCallback, useId } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

// Each hook instance fetches its own single-use token (tokens are single-use
// server-side, so a shared/cached token would break a second form submission).
const fetchToken = () =>
  fetch(`${API}/api/form-token`)
    .then(r => r.json())
    .then(d => d.token || '')
    .catch(() => '');

export const useBotShield = () => {
  const [token, setToken] = useState('');
  const [hp, setHp] = useState('');

  const refresh = useCallback(async () => {
    setToken(await fetchToken());
  }, [setToken]);

  useEffect(() => {
    let active = true;
    fetchToken().then(t => { if (active) setToken(t); });
    return () => { active = false; };
  }, []);

  return { shieldFields: { website: hp, formToken: token }, hp, setHp, refresh };
};

// Shared handling for bot-shield-protected form responses (429/400).
export const shieldErrorMessage = (status, refresh) => {
  if (status === 429) return 'Too many requests — please try again in a minute.';
  if (status === 400) {
    refresh();
    return 'Verification failed — please try again.';
  }
  return null;
};

export const HoneypotField = ({ value, onChange }) => {
  const id = useId();
  return (
    <div aria-hidden="true" style={{ position: 'absolute', left: '-9999px', top: 'auto', width: '1px', height: '1px', overflow: 'hidden' }}>
      <label htmlFor={id}>Website</label>
      <input
        id={id}
        type="text"
        name="website"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};
